var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-image__wrapper"},[(_vm.clientLogo)?_c('img',{staticClass:"client-image",attrs:{"src":_vm.clientLogo,"alt":"Client logo"}}):_c('h4',[_vm._v(_vm._s(_vm.clientName))])])}
var staticRenderFns = []

export { render, staticRenderFns }